import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const AssigneeOptionContainer = ({
  children
}) => /*#__PURE__*/_jsx(View, {
  paddingInline: "500",
  paddingBlock: "200",
  as: "div",
  children: children
});
AssigneeOptionContainer.displayName = 'AssigneeOptionContainer';
export default AssigneeOptionContainer;